<template>
    <el-drawer :modal="false" 
        title="Filter"
        :visible.sync="is_visible"
        class="drawer-filter-customer"
        size="20%"
    >
        <b-container>
            <b-row class="text-end">
                <b-col cols="12">
                    <div class="d-flex justify-content-end">
                        <b-button variant="primary" @click="resetFilter">Reset</b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Cases Id">
                        <b-form-input type="number" v-model="filters.search.prod_id" placeholder="Filter By Cases ID" v-on:keydown.enter="searchByFilter()"></b-form-input>
                    </b-form-group>
                </b-col>
								<b-col cols="12">
                    <b-form-group label="Customer Id">
                        <b-form-input type="number" v-model="filters.search.prod_customer_id" placeholder="Filter By Customer ID" v-on:keydown.enter="searchByFilter()"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols=12>
                    <b-form-group label="Agent Name">
                        <el-select v-model="filters.search.prod_agent_id" placeholder="Filter By Agent Name" @change="searchByFilter()" filterable clearable>
                            <el-option value="">-</el-option>
                            <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
								<b-col cols="12">
                    <b-form-group label="Customer Name">
                        <b-form-input type="text" v-model="filters.search.prod_customer_name" placeholder="Filter By Customer Name" v-on:keydown.enter="searchByFilter()"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="nonPropertyStatus && nonPropertyStatus.length > 0 && current_tab_type !== 'property'">
                    <b-form-group label="Sub Status">
                        <el-select v-model="filters.search.prod_status" placeholder="Filter By Sub Status" @change="searchByFilter()" clearable>
                            <el-option value="">-</el-option>
                            <el-option
                            v-for="(item, index) in nonPropertyStatus"
                            :key="index"
                            :label="item.status"
                            :value="item.status">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <!--property is using bank status for sub ?-->
                <b-col cols="12" v-if="propertyBankStatus && propertyBankStatus.length > 0 && current_tab_type === 'property'">
                    <b-form-group label="Sub Status">
                        <el-select v-model="filters.search.prod_bnk_stage_status" placeholder="Filter By Sub Status" @change="searchByFilter()" clearable>
                            <el-option value="">-</el-option>
                            <el-option
                            v-for="(item, index) in propertyBankStatus"
                            :key="index"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Bank">
                        <el-select v-model="filters.search.prod_bnk_codes" placeholder="Filter By Banks" @change="searchByFilter()" clearable>
                            <el-option value="">-</el-option>
                            <el-option
                            v-for="item in bank_list"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Loan Officer">
                        <el-select v-model="filters.search.prod_loan_officer_id" placeholder="Filter By Loan Officer" @change="searchByFilter()" clearable>
                            <el-option value="">-</el-option>
                            <el-option
                            v-for="item in userLoanOfficerList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols=12>
                    <b-form-group label="Created By">
                        <el-select v-model="filters.search.prod_created_by" placeholder="Filter By Created By" @change="searchByFilter()" filterable clearable>
                            <el-option value="">-</el-option>
                            <el-option
                            v-for="item in userList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Filter By SSA">
                        <el-select v-model="filters.search.prod_ssa_id" placeholder="Filter By SSA" @change="searchByFilter" filterable allow-create clearable>
                            <el-option value="">All</el-option>
                            <el-option
                            v-for="item in userAdvisorList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Filter By Date Type">
                        <el-select v-model="filters.search.prod_date_range.type_date" placeholder="Filter By Date Type" @change="changeDateType()">
                            <el-option value="">-</el-option>
                            <el-option
                            v-for="item in dateTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="filters.search.prod_date_range.type_date">
                    <base-input :label="dateTypeLabel">
                        <div class="">
                            <div class="mb-2">
                                <el-date-picker
                                    v-model="filters.search.prod_date_range.start_date"
                                    type="date"
                                    placeholder="Date From"
                                    value-format="yyyy-MM-dd"
                                    @change="searchByFilter()"
                                />
                            </div>
                            <div class="mb-2 w-100 text-center">
                                To
                            </div>
                            <div class="">
                                <el-date-picker
                                    v-model="filters.search.prod_date_range.end_date"
                                    type="date"
                                    placeholder="Date Until"
                                    value-format="yyyy-MM-dd"
                                    @change="searchByFilter()"
                                />
                            </div>
                        </div>
                    </base-input>
                </b-col>
            </b-row>
        </b-container>
        
    </el-drawer>
</template>
<script>
import _ from 'lodash'
import { Drawer, Select, Option, DatePicker } from 'element-ui'
import { debounce } from '@/assets/js/httpImports.js'
import {BANK_STATUS} from '@/assets/js/status.js'
import { mapState } from 'pinia'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useProductStore } from '@/stores/productStore'
import { useLookupStore } from '@/stores/lookupStore'

export default {
    props: {
			tableFilters: Object,
    },
    components: {
        [Drawer.name]: Drawer,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            is_visible: false,
						BANK_STATUS: BANK_STATUS,
            filters: {
								page:1,
								paginate:25,
								search:{
									prod_id:'',
									prod_customer_id:'',
									prod_loan_officer_id:'',
									prod_ssa_id:'',
									prod_case_no:'',
									prod_customer_name:'',
									prod_customer_basket:'',
									prod_type:'',
									prod_detail_table:'',
									prod_status:'',
									prod_agent_id:'',
									prod_agent_username:'',
									prod_agent_company:'',
									prod_main_status:'',
									prod_total_sales:'',
									prod_submitted_date:'',
									prod_acceptance_date:'',
									prod_custom_identifier:'',
									prod_application_code:'',
									prod_created_by:'',
									prod_updated_by:'',
									prod_bnk_codes:'',
									prod_date_range:{
											type_date:'',
											start_date:'',
											end_date:''
									},
									prod_bnk_stage_status: '',
									prod_oth_status:''
								}
            },
						propertyBankStatus:[],
						nonPropertyStatus:[],
            agents_list: [],
						dateTypeLabel: 'Chose Date Type',
            dateTypes: [
                {
                    value:'prod_submitted_date',
                    label:'Submited At',
                },
                {
										value:'prod_acceptance_date',
                    label:'Acceptance At',
                },
                {
										value:'prod_created_date',
                    label:'Created At',
                },
                {
										value:'prod_updated_date',
                    label:'Updated At',
                },
            ],
        }
    },
		mounted(){
        this.propertyBankStatus = []
        this.BANK_STATUS.forEach((item) => {
            this.propertyBankStatus.push({
                label: item.label,
                value: item.value
            })
        })
    },
		computed: {
        ...mapState(useAccessControlStore, ['userLoanOfficerList', 'userList','userAdvisorList']),
        ...mapState(useProductStore, [
					'bank_list',
					'current_tab_type',
					'list_sub_mortgage_status',
					'list_sub_insurance_status',
					'list_sub_other_loan_status',
					'list_sub_mhlv_status',
					'list_sub_personal_loan_status'
				]),
		},
		watch:{
				tableFilters:{
					handler(newVal){
						this.filters = {...this.filters, ...newVal};
						console.log(this.filters);
					},
					immediate: true
       },    
				current_tab_type:{
					handler(newVal){
						switch (newVal) {
							case 'insurance':
								this.nonPropertyStatus = this.list_sub_insurance_status
								break;
							case 'refinance':
							case 'mortgage':
								this.nonPropertyStatus = this.list_sub_mortgage_status
								break;
							case 'other':
								this.nonPropertyStatus = this.list_sub_other_loan_status
								break;
							case 'personal_loan':
								this.nonPropertyStatus = this.list_sub_personal_loan_status
								break;
							case 'mhlv':
								this.nonPropertyStatus = this.list_sub_mhlv_status
								break;
							default:
								this.nonPropertyStatus = this.list_sub_mortgage_status
								break;
						}
					},
					immediate: true
       },    
    },    
    methods: {
        show() {
					this.is_visible = true
        },
        searchByFilter() {
					this.filters.search.prod_type = this.current_tab_type;
					this.filters.page = 1;
					this.filters.is_reset_summary = true;
          this.$emit('onFilter',this.filters)
        },
        resetFilter() {
						this.filters = _gHlp.resetFormAttributes(this.filters);
						this.filters.is_reset = true;
						this.searchByFilter()
        },
        changeDateType() {
					if(this.filters.search.prod_date_range.type_date == ''){
							this.dateTypeLabel = 'Chose Date Type';
							this.filters.search.prod_date_range = {
								type_date:'',
								start_date:'',
								end_date:''
							}
							this.searchByFilter()
					}else{
						this.filters.search.prod_date_range.start_date = '';
						this.filters.search.prod_date_range.end_date = '';
						let type_date = this.filters.search.prod_date_range.type_date;
						let selectDateType = _.find(this.dateTypes, (o)=>{ return o.value == type_date; });
						this.dateTypeLabel = selectDateType.label;
					}
        },
    }
}
</script>